"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeDeviceInstallationStatus = exports.NodeDevicePort = exports.DEPRECATED_NODE_TYPES = exports.NodeTypes = exports.ExternalNodeTypes = void 0;
exports.ExternalNodeTypes = [
    'ex_windmachine',
    'ex_pump',
    'ex_valve',
    'ex_filter',
    'ex_fertigation',
    'ex_communication',
    'ex_twig_valve',
    'ex_twig_mc_gtwy',
    'ex_twig_rpt',
];
exports.NodeTypes = [
    'scd',
    'ln_scd',
    'nn_scd',
    'gtwy',
    'ln_gtwy',
    'rpt',
    'trp',
    'dn_trp',
    'y',
    'dn_y',
    'ln_r',
    ...exports.ExternalNodeTypes,
];
exports.DEPRECATED_NODE_TYPES = ['dcd', 'fan', 'vrt', 'x'];
exports.NodeDevicePort = ['rj11', 'stereo', 'sdi'];
var NodeDeviceInstallationStatus;
(function (NodeDeviceInstallationStatus) {
    NodeDeviceInstallationStatus["PLANNED"] = "PLANNED";
    NodeDeviceInstallationStatus["INSTALLED"] = "INSTALLED";
})(NodeDeviceInstallationStatus || (exports.NodeDeviceInstallationStatus = NodeDeviceInstallationStatus = {}));
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["CONNECTED"] = "CONNECTED";
    ConnectionStatus["UNKNOWN"] = "UNKNOWN";
})(ConnectionStatus || (ConnectionStatus = {}));
//# sourceMappingURL=nodes.js.map